import angular from 'angular';
import { app } from '../../bootstrap/core';

app.directive('trackEvent', function (trackingService) {
  'ngInject';
  return {
    link: (scope, elem, attrs) => {
      elem.on('click', function (ev) {
        const { trackEvent, trackData } = attrs;
        trackingService.trackEvent(trackEvent, angular.fromJson(trackData));
      });
    },
  };
});



// WEBPACK FOOTER //
// ./src/app/common/directives/plausible.directive.js